import React, {PropTypes} from 'react';

import * as color from '../../../constants/colors';


class AddDiamondConfirm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      closing: false,
      bodyTop: 0,
      marginOffset: 0,
    };

    // Bind event listeners
    this.adjustHeight = this.adjustHeight.bind(this);
  }

  componentWillMount() {
    window.addEventListener('resize', this.adjustHeight, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.adjustHeight, false);
  }

  componentWillUpdate(nextProps, nextState) {
    if(this.state.open !== nextProps.open) {
      if(this.state.open && !nextProps.open && !this.state.closing) {
        this.closeAlert();
      } 
      if(nextProps.open) {
        this.openAlert();
      }
    }
  }

  getAlertBody() {
    let alert = null;
    let alerts = document.getElementsByClassName('alertBody');
    for(let i = 0; i < alerts.length; i++) {
      if(getComputedStyle(alerts[i], null).display === 'block') {
        alert = alerts[i];
        break;
      }
    }
    return alert;
  }

  adjustHeight() {
    let foundAlert = this.getAlertBody();
    if(foundAlert) {
      let offset = (window.innerHeight - (foundAlert.offsetHeight + 128)) / 2;
      this.setState({ marginOffset: offset > 0 ? offset + 'px' : 0 });
    }
  }

  openAlert() {
    this.setState({ open: true }, () => {
      let alert = null;
      do {
        alert = this.getAlertBody();
        setTimeout(() => {
          if(alert) {
            let offset = (window.innerHeight - (alert.offsetHeight + 128)) / 2;
            this.setState({ 
              bodyTop: '64px',
              marginOffset: offset > 0 ? offset + 'px' : 0, 
            });
          }
        }, 25);
      } while(!alert);
    });
  }

  closeAlert() {
    this.setState({ 
      closing: true,
      bodyTop: '0',
    });
    setTimeout(() => {
      this.setState({
        open: false,
        closing: false,
      });
    }, 400)
  }

  alertStyles() {
    return {
      display: this.state.open ? 'block' : 'none', 
    }
  }

  render() {

    return (
      <div 
        className={this.state.closing ? 'AddDiamondConfirm RhinoAlert out' : 'AddDiamondConfirm RhinoAlert'} 
        style={this.alertStyles()}>
        <div 
          className='alertBody'
          style={{
            display: this.state.open ? 'block' : 'none',
            top: this.state.bodyTop,
            marginTop: this.state.marginOffset,
            marginBottom: this.state.marginOffset === 0 ? '64px' : 0,
          }}>
          <div className='cardSubmitWrapper'>
            <div className='cardSubmitTitle'>Customer Card Updated</div>
            <div className='cardSubmitButtons'>
              <button className={'shareButton actionButton'} onClick={this.props.cardNav.bind(this)}>
                View Card
              </button>
              <button className={'diamondButton secondaryButton'} onClick={this.props.diamondsNav.bind(this)}>
                Back to Diamonds
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddDiamondConfirm;